module.exports = __webpack_public_path__ + "static/parnell-6a59ce124f035e884e794ec3a1f2ff78.jpg";